import { lazy } from "react";

// Lazy-loaded Print Components
const CategoryWiseReportPrintAdmin = lazy(
  () => import("../components/audit/view/printAdmin/CategoryWiseReportPrintAdmin"),
);
const GenerateBarcodePrintAdmin = lazy(
  () => import("../components/Inventory/view/GenerateBarcodePrintAdmin"),
);
const StockReportPrintAdmin = lazy(
  () => import("../components/Inventory/view/StockReportPrintAdmin"),
);
const DateWiseSalesSummaryNBRPrintAdmin = lazy(
  () =>
    import("../components/accounts/view/printAdmins/DateWiseSalesSummaryNBRPrintAdmin"),
);
const DateWiseSalesSummaryPrintAdmin = lazy(
  () =>
    import("../components/accounts/view/printAdmins/DateWiseSalesSummaryPrintAdmin"),
);
const PaymentRealizationSalesPrintAdmin = lazy(
  () =>
    import("../components/accounts/view/printAdmins/PaymentRealizationSalesPrintAdmin"),
);
const PaymentTypeWiseSalesDetailsPrintAdmin = lazy(
  () =>
    import("../components/accounts/view/printAdmins/PaymentTypeWiseSalesDetailsPrintAdmin"),
);
const PaymentTypeWiseSalesSummaryPrintAdmin = lazy(
  () =>
    import("../components/accounts/view/printAdmins/PaymentTypeWiseSalesSummaryPrintAdmin"),
);
const BillAdmin = lazy(() => import("../components/bill/view/BillAdmin"));
const ReturnBillAdmin = lazy(
  () => import("../components/bill/view/ReturnBillAdmin"),
);
const PrintRequisition = lazy(
  () => import("../components/orderRequisition/PrintRequisition"),
);
const PaymentAdvicePrintAdmin = lazy(
  () => import("../components/paymentAdvice/view/PaymentAdvicePrintAdmin"),
);
const PaymentAdviceReportAuditPrint = lazy(
  () =>
    import("../components/paymentAdvice/view/printAudit/PaymentAdviceReportAuditPrint"),
);
const GeneralPOPrintAdmin = lazy(
  () => import("../components/purchaseOrder/view/GeneralPOPrintAdmin"),
);
const POPrintAdmin = lazy(
  () => import("../components/purchaseOrder/view/POPrintAdmin"),
);
const ReceivedPOPrintAdmin = lazy(
  () => import("../components/purchaseOrder/view/ReceivedPOPrintAdmin"),
);
const ReturnPOPrintAdmin = lazy(
  () => import("../components/purchaseOrder/view/ReturnPOPrintAdmin"),
);
const CashDistributionReportPrint = lazy(
  () => import("../containers/invoice/CashDistributionReportPrint"),
);
const MultipleInvoicePrint = lazy(
  () => import("../containers/invoice/MultipleInvoicePrint"),
);
const OrderSummaryReportPrint = lazy(
  () => import("../containers/invoice/OrderSummaryReportPrint"),
);
const StyleWiseOrderSummaryReportPrint = lazy(
  () => import("../containers/invoice/StyleWiseOrderSummaryReportPrint"),
);

export const printRoutes = [
  { path: "/Print-Requisition", component: PrintRequisition },
  { path: "/PrintPO", component: POPrintAdmin },
  { path: "/PrintGeneralPO", component: GeneralPOPrintAdmin },
  { path: "/PrintReceivedPO", component: ReceivedPOPrintAdmin },
  { path: "/PrintReturnPO", component: ReturnPOPrintAdmin },
  { path: "/PrintPaymentAdvice", component: PaymentAdvicePrintAdmin },
  { path: "/PrintStockReport", component: StockReportPrintAdmin },
  { path: "/PrintBarcode", component: GenerateBarcodePrintAdmin },
  { path: "/PrintBill", component: BillAdmin },
  { path: "/PrintReturnBill", component: ReturnBillAdmin },
  { path: "/Multiple-Invoice-Print", component: MultipleInvoicePrint },
  { path: "/Print-Seller-Requisition", component: PrintRequisition },
  {
    path: "/PrintDateWiseSalesSummaryNBR",
    component: DateWiseSalesSummaryNBRPrintAdmin,
  },
  {
    path: "/PrintDateWiseSalesSummary",
    component: DateWiseSalesSummaryPrintAdmin,
  },
  {
    path: "/PrintPaymentTypeWiseSalesSummary",
    component: PaymentTypeWiseSalesSummaryPrintAdmin,
  },
  {
    path: "/PrintPaymentTypeWiseSalesDetails",
    component: PaymentTypeWiseSalesDetailsPrintAdmin,
  },
  {
    path: "/PrintDateWisePaymentRealization",
    component: PaymentRealizationSalesPrintAdmin,
  },
  { path: "/Order-Summary-Report-Print", component: OrderSummaryReportPrint },
  {
    path: "/Style-Wise-Order-Summary-Report-Print",
    component: StyleWiseOrderSummaryReportPrint,
  },
  {
    path: "/Cash-Distribution-Report-Print",
    component: CashDistributionReportPrint,
  },
  {
    path: "/PrintPaymentAdviceReport",
    component: PaymentAdviceReportAuditPrint,
  },
  {
    path: "/PrintCategoryWiseReport",
    component: CategoryWiseReportPrintAdmin,
  },
];
